import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../../constants/AppTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useDispatch } from 'react-redux';
import { PURCHASE_DELETE_PRODUCT_ITEM } from '../../../../store/inventorySlice';
import { PurchaseProductList } from '../../../../helpers/models/Models';

const ProductPurchaseItemView = () => {
  const dispatch = useDispatch();
  const { PurchaseProductList } = useSelector((state: RootState) => state.inventory);
  const columns = useMemo(() => [
    { header: 'SN', accessor: 'sn', sortable: false },
    { header: 'Store Name', accessor: 'store', sortable: true },
    { header: 'Product', accessor: 'product', sortable: false },
    { header: 'Supplier', accessor: 'suppiler', sortable: false },
    { header: 'Purchase Date', accessor: 'pur_sale_date', sortable: false },
    { header: 'Purchase Quantity', accessor: 'purchase_qty', sortable: false },
    { header: 'Total Amount', accessor: 'tot_amt', sortable: false },
    { header: 'Actions', accessor: 'actions', action: true },
  ], []);
  const modifiedData: PurchaseProductList[] = useMemo(() => {
    if (!PurchaseProductList) return [];
    return PurchaseProductList.map((item, index) => ({
      ...item,
      sn: index + 1,
    }));
  }, [PurchaseProductList]);

  const handleDelete = (sn: PurchaseProductList) => {
    dispatch(PURCHASE_DELETE_PRODUCT_ITEM(sn.product));
  };

  return (
    <Fragment>
      <AppTable
        columns={columns}
        data={modifiedData}
        onDelete={handleDelete}
      />
    </Fragment>
  );
}

export default ProductPurchaseItemView